<div class="announcements-area ptb-80">
  <div class="container">
    <div class="section-title">
      <h3 i18n="@@pressRoomAnnouncementsTitle">Announcements</h3>
      <div class="bar"></div>
    </div>
    <div class="row">
      <div class="d-flex" *ngFor="let item of announcements; index as i">
        <app-announcement-item [announcement]="item"></app-announcement-item>
      </div>
    </div>
  </div>
</div>
